module.exports = __webpack_public_path__ + "static/media/shops.1d8d0240.png";